import type { NavGroup } from '../../../types/proposal-content';

interface ProposalSidebarLeftProps {
  groups: NavGroup[];
  currentPage: string;
  onNavigate: (pageId: string) => void;
  onOpenModal: () => void;
}

export function ProposalSidebarLeft({ groups, currentPage, onNavigate, onOpenModal }: ProposalSidebarLeftProps) {
  return (
    <aside className="w-p-sidebar shrink-0 sticky top-[56px] h-[calc(100vh-56px)] overflow-y-auto border-r border-proposal-border py-6 bg-proposal-bg hidden md:block">
      <nav>
        {groups.map((group, i) => (
          <div key={i} className="mb-2">
            <div className="text-[11px] font-semibold text-proposal-fg3 uppercase tracking-wider px-4 pb-1.5">
              {group.title}
            </div>
            {group.items.map((item) => (
              <a
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className={`block px-4 py-1.5 text-[13px] cursor-pointer transition-colors border-l-2 ${
                  currentPage === item.id
                    ? 'text-proposal-fg1 border-l-proposal-accent bg-proposal-accent-dim font-medium'
                    : 'text-proposal-fg2 border-l-transparent hover:text-proposal-fg1 hover:bg-proposal-bg2'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>
        ))}
        {/* Always show accept CTA at bottom */}
        <div className="mb-2">
          <a
            onClick={onOpenModal}
            className="block px-4 py-1.5 text-[13px] cursor-pointer transition-colors border-l-2 border-l-transparent text-proposal-accent hover:bg-proposal-bg2 font-medium"
          >
            Aceptar propuesta →
          </a>
        </div>
      </nav>
    </aside>
  );
}
